import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PatientData {
  patient_id: string;
  first_name: string;
  last_name: string;
  email: string;
  created_at?: string;
}

interface PatientContextType {
  recentlyCreatedPatient: PatientData | null;
  setRecentlyCreatedPatient: (patient: PatientData | null) => void;
  clearRecentlyCreatedPatient: () => void;
}

const PatientContext = createContext<PatientContextType | undefined>(undefined);

interface PatientProviderProps {
  children: ReactNode;
}

export const PatientProvider: React.FC<PatientProviderProps> = ({ children }) => {
  const [recentlyCreatedPatient, setRecentlyCreatedPatient] = useState<PatientData | null>(null);

  const clearRecentlyCreatedPatient = () => {
    setRecentlyCreatedPatient(null);
  };

  return (
    <PatientContext.Provider 
      value={{ 
        recentlyCreatedPatient, 
        setRecentlyCreatedPatient, 
        clearRecentlyCreatedPatient 
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};

export const usePatient = (): PatientContextType => {
  const context = useContext(PatientContext);
  if (context === undefined) {
    throw new Error('usePatient must be used within a PatientProvider');
  }
  return context;
};

export default PatientContext;
